export const ENUM_ROLES = {
  SUPERADMIN: 'SUPERADMIN',
  ADMIN: 'ADMIN',
  DIRECTOR: 'DIRECTOR',
  GOVERNMENT_OFFICIAL: 'FUNCIONARIO',
  CITIZEN: 'CIUDADANO',
  COLLABORATOR: 'COLABORADOR',
  TECHNICAL_ADMIN: 'TECHNICAL_ADMIN',
};

export const ENUM_MODULES = {
  REPORTS: 'REPORTS',
  EMISSIONS: 'EMISSIONS',
  USERS: 'USERS',
};

export const ENUM_PERMISSIONS = {
  //CREATE

  MOD_SYSTEM_CONFIGURATION_COLORS_CREATE: 'MOD_SYSTEM_CONFIGURATION_COLORS:CREATE',
  MOD_SYSTEM_CONFIGURATION_SMTP_CREATE: 'MOD_SYSTEM_CONFIGURATION_SMTP:CREATE',
  MOD_SYSTEM_CONFIGURATION_RENAPO_CREATE: 'MOD_SYSTEM_CONFIGURATION_RENAPO:CREATE',
  MOD_USERS_MANAGEMENT_CREATE: 'MOD_USERS_MANAGEMENT:CREATE',
  MOD_USERS_INVITATIONS_CREATE: 'MOD_USERS_INVITATIONS:CREATE',
  MOD_EMISSION_CREATE: 'MOD_EMISSION:CREATE',
  MOD_DEPENDENCIES_CREATE: 'MOD_DEPENDENCIES:CREATE',
  MOD_INTEROP_SERVICES_CREATE: 'MOD_INTEROP_SERVICES:CREATE',
  MOD_ROLES_CREATE: 'MOD_ROLES:CREATE',
  MOD_CERTIFICATE_CONFIGURATION_TYPE_CREATE: 'MOD_CERTIFICATE_CONFIGURATION_TYPE:CREATE',
  MOD_CERTIFICATE_CONFIGURATION_XSD_CREATE: 'MOD_CERTIFICATE_CONFIGURATION_XSD:CREATE',
  MOD_CERTIFICATE_CONFIGURATION_PDF_CREATE: 'MOD_CERTIFICATE_CONFIGURATION_PDF:CREATE',

  //READ
  MOD_INTEROP_SERVICES_READ: 'MOD_INTEROP_SERVICES:READ',
  MOD_INTEROP_METRICS_READ: 'MOD_INTEROP_METRICS:READ',
  MOD_INTEROP_HISTORY_READ: 'MOD_INTEROP_HISTORY:READ',

  MOD_AUDIT_READ: 'MOD_AUDIT:READ',
  MOD_NOC_READ: 'MOD_NOC:READ',

  MOD_EMISSION_READ: 'MOD_EMISSION:READ',
  MOD_CONFIG_CERT_READ: 'MOD_CONFIG_CERT:READ',
  MOD_CONFIG_XSD_READ: 'MOD_CONFIG_XSD:READ',
  MOD_CONFIG_PDF_READ: 'MOD_CONFIG_PDF:READ',

  MOD_VALIDATION_READ: 'MOD_VALIDATION:READ',
  MOD_REPORTS_READ: 'MOD_REPORTS:READ',

  MOD_DEPENDENCIES_READ: 'MOD_DEPENDENCIES:READ',
  MOD_CATASTRO_READ: 'MOD_CATASTRO:READ',
  MOD_USERS_MANAGEMENT_READ: 'MOD_USERS_MANAGEMENT:READ',
  MOD_USERS_INVITATIONS_READ: 'MOD_USERS_INVITATIONS:READ',

  MOD_ROLES_READ: 'MOD_ROLES:READ',
  MOD_SYSTEM_CONFIGURATION_COLORS_READ: 'MOD_SYSTEM_CONFIGURATION_COLORS:READ',
  MOD_SYSTEM_CONFIGURATION_SMTP_READ: 'MOD_SYSTEM_CONFIGURATION_SMTP:READ',
  MOD_SYSTEM_CONFIGURATION_RENAPO_READ: 'MOD_SYSTEM_CONFIGURATION_RENAPO:READ',

  MOD_DATAMART_READ: 'MOD_DATAMART:READ',
  MOD_AI_READ: 'MOD_AI:READ',

  MOD_CERTIFICATE_CONFIGURATION_TYPE_READ: 'MOD_CERTIFICATE_CONFIGURATION_TYPE:READ',
  MOD_CERTIFICATE_CONFIGURATION_XSD_READ: 'MOD_CERTIFICATE_CONFIGURATION_XSD:READ',
  MOD_CERTIFICATE_CONFIGURATION_PDF_READ: 'MOD_CERTIFICATE_CONFIGURATION_PDF:READ',

  //DELETE
  MOD_USERS_MANAGEMENT_DELETE:'MOD_USERS_MANAGEMENT:DELETE',
  MOD_ROLES_DELETE: 'MOD_ROLES:DELETE',
  MOD_USERS_INVITATIONS_DELETE: 'MOD_USERS_INVITATIONS:DELETE',
  MOD_DEPENDENCIES_DELETE: 'MOD_DEPENDENCIES:DELETE',
  MOD_INTEROP_SERVICES_DELETE: 'MOD_INTEROP_SERVICES:DELETE',
  MOD_SYSTEM_CONFIGURATION_COLORS_DELETE: 'MOD_SYSTEM_CONFIGURATION_COLORS:DELETE',
  MOD_SYSTEM_CONFIGURATION_SMTP_DELETE: 'MOD_SYSTEM_CONFIGURATION_SMTP:DELETE',
  MOD_SYSTEM_CONFIGURATION_RENAPO_DELETE: 'MOD_SYSTEM_CONFIGURATION_RENAPO:DELETE',
  MOD_CERTIFICATE_CONFIGURATION_TYPE_DELETE: 'MOD_CERTIFICATE_CONFIGURATION_TYPE:DELETE',

  //UPDATE
  MOD_ROLES_UPDATE: 'MOD_ROLES:UPDATE',
  MOD_SYSTEM_CONFIGURATION_COLORS_UPDATE: 'MOD_SYSTEM_CONFIGURATION_COLORS:UPDATE',
  MOD_SYSTEM_CONFIGURATION_RENAPO_UPDATE: 'MOD_SYSTEM_CONFIGURATION_RENAPO:UPDATE',
  MOD_SYSTEM_CONFIGURATION_SMTP_UPDATE: 'MOD_SYSTEM_CONFIGURATION_SMTP:UPDATE',
  MOD_USERS_INVITATIONS_UPDATE: 'MOD_USERS_INVITATIONS:UPDATE',
  MOD_DEPENDENCIES_UPDATE: 'MOD_DEPENDENCIES:UPDATE',
  MOD_INTEROP_SERVICES_UPDATE: 'MOD_INTEROP_SERVICES:UPDATE',
  MOD_CERTIFICATE_CONFIGURATION_TYPE_UPDATE: 'MOD_CERTIFICATE_CONFIGURATION_TYPE:UPDATE',
  MOD_USERS_MANAGEMENT_UPDATE:'MOD_USERS_MANAGEMENT:UPDATE'
};

export const ENUM_ACTIONS = {
  Create: 'Crear ',
  Update: 'Editar ',
  Delete: 'Eliminar ',
};
